<script setup lang="ts">
import { ArrowLeft } from 'lucide-vue-next'
import PartooIframe from '../review/ReviewSettingsPage/platforms/PartooIframe.vue'
import EReputationSettingsMenu from './EReputationSettingsMenu.vue'

const pageMapping = {
  stores: 'businesses',
  reviews: 'reviewManagement',
  statistics: 'reviewAnalytics',
  settingsConnection: 'partnerConnections',
  reviewAutoReplyWithoutComments: 'reviewAutoReplyWithoutComments',
  reviewAutoReplyWithComments: 'reviewAutoReplyWithComments',
  posts: 'posts',
  analytics: 'analytics',
  presenceManagement: 'presenceManagement'
} as const

const subPageTitleKeys = {
  settingsConnection: 'pages.eReputation.settings.platforms.title',
  reviewAutoReplyWithoutComments: 'pages.eReputation.autoReply.withoutComments.title',
  reviewAutoReplyWithComments: 'pages.eReputation.autoReply.withComments.title'
} as const

const { t } = useI18n()
const route = useRoute()

const routePage = computed(() => route.params.page as string)
const isSettingsMenu = computed(() => routePage.value === 'settings')
const partooPage = computed(() => pageMapping[routePage.value as keyof typeof pageMapping])
const backTitleKey = computed(() => subPageTitleKeys[routePage.value as keyof typeof subPageTitleKeys])
</script>

<template>
  <div class="min-h-screen">
    <EReputationSettingsMenu v-if="isSettingsMenu" />

    <div v-else-if="backTitleKey" class="flex h-screen flex-col">
      <div class="flex shrink-0 items-center gap-2 border-b border-border px-4 py-3">
        <Button variant="ghost" size="icon-sm" as-child>
          <RouterLink
            :to="{ name: 'EReputation', params: { page: 'settings' } }"
            :aria-label="t('pages.eReputation.settings.back')"
          >
            <ArrowLeft />
          </RouterLink>
        </Button>
        <h1 class="text-lg font-medium text-foreground">{{ t(backTitleKey) }}</h1>
      </div>
      <PartooIframe :page="partooPage" container-class="min-h-0 flex-1" />
    </div>

    <PartooIframe v-else-if="partooPage" :page="partooPage" />
  </div>
</template>
